"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Portal_1 = __importDefault(require("./Portal"));

var Modal_styles_1 = require("./Modal.styles");

var defaultProps = {
  headerText: '',
  disableBackdropClick: false,
  className: '',
  testHook: 'Modal',
  Header: Modal_styles_1.ModalHeader,
  Content: Modal_styles_1.ModalContent,
  Backdrop: Modal_styles_1.ModalBackdrop,
  CloseButton: Modal_styles_1.ModalCloseButton,
  mode: 'light'
};

var Modal = function Modal(_a) {
  var children = _a.children,
      isOpen = _a.isOpen,
      closeModal = _a.closeModal,
      headerText = _a.headerText,
      disableBackdropClick = _a.disableBackdropClick,
      className = _a.className,
      testHook = _a.testHook,
      Header = _a.Header,
      Content = _a.Content,
      Backdrop = _a.Backdrop,
      CloseButton = _a.CloseButton,
      mode = _a.mode;
  return react_1.default.createElement(Portal_1.default, {
    isOpen: isOpen,
    rootClassname: "modal-root"
  }, react_1.default.createElement(Modal_styles_1.ModalWrapper, null, react_1.default.createElement(Backdrop, {
    "data-cv-test": testHook + ".Backdrop",
    onClick: function onClick(e) {
      return disableBackdropClick ? null : closeModal(e);
    }
  }), react_1.default.createElement(Content, {
    className: className,
    "data-cv-test": testHook,
    role: "dialog",
    "aria-modal": "true",
    mode: mode
  }, react_1.default.createElement(Modal_styles_1.HeaderContainer, null, react_1.default.createElement(Header, {
    mode: mode
  }, headerText), react_1.default.createElement(CloseButton, {
    onClick: closeModal,
    "aria-label": "Close Modal",
    "data-cv-test": testHook + ".Close",
    mode: mode
  }, react_1.default.createElement(Modal_styles_1.CloseIcon, null))), react_1.default.createElement(Modal_styles_1.ModalScroll, null, children))));
};

Modal.defaultProps = defaultProps;
exports.default = Modal;